/**
 * Poly 期权式看板 — 资产注册表（前端）
 *
 * 架构：
 * - 每个资产一条配置：Polymarket eventSlug + Binance 现货交易对 + 主题色
 * - 盘口数据走 Worker `GET /api/poly-options?asset=`
 * - 现货价 / K 线：浏览器直连 Binance REST + WS（低延迟）；失败可回退轮询
 * - 后续加 HYPE / LIT：补齐 eventSlug 并把 enabled 设为 true 即可
 */

export const POLY_OPTIONS_ASSETS = [
  {
    id: 'btc',
    symbol: 'BTC',
    label: '比特币',
    category: '加密 · 比特币',
    binanceSymbol: 'BTCUSDT',
    eventSlug: 'what-price-will-bitcoin-hit-before-2027',
    polyUrl: 'https://polymarket.com/zh/event/what-price-will-bitcoin-hit-before-2027',
    titleZh: '比特币将在2026年达到什么价格？',
    accent: '#F7931A',
    enabled: true,
  },
  {
    id: 'eth',
    symbol: 'ETH',
    label: '以太坊',
    category: '加密 · 以太坊',
    binanceSymbol: 'ETHUSDT',
    eventSlug: 'what-price-will-ethereum-hit-before-2027',
    polyUrl: 'https://polymarket.com/zh/event/what-price-will-ethereum-hit-before-2027',
    titleZh: '以太坊将在2026年达到什么价格？',
    accent: '#627EEA',
    enabled: true,
  },
  {
    id: 'sol',
    symbol: 'SOL',
    label: 'Solana',
    category: '加密 · Solana',
    binanceSymbol: 'SOLUSDT',
    eventSlug: 'what-price-will-solana-hit-before-2027',
    polyUrl: 'https://polymarket.com/zh/event/what-price-will-solana-hit-before-2027',
    titleZh: 'Solana 将在2026年达到什么价格？',
    accent: '#14F195',
    enabled: true,
  },
  {
    id: 'hype',
    symbol: 'HYPE',
    label: 'Hyperliquid',
    category: '加密 · HYPE',
    binanceSymbol: 'HYPEUSDT',
    eventSlug: '',
    polyUrl: '',
    titleZh: 'HYPE 价格目标（待接入）',
    accent: '#97FCE4',
    enabled: false,
    note: '待配置 Polymarket eventSlug',
  },
  {
    id: 'lit',
    symbol: 'LIT',
    label: 'LIT',
    category: '加密 · LIT',
    binanceSymbol: 'LITUSDT',
    eventSlug: '',
    polyUrl: '',
    titleZh: 'LIT 价格目标（待接入）',
    accent: '#A78BFA',
    enabled: false,
    note: '待配置 Polymarket eventSlug',
  },
];

export function getPolyOptionsAsset(id) {
  return POLY_OPTIONS_ASSETS.find((a) => a.id === String(id || '').toLowerCase()) || POLY_OPTIONS_ASSETS[0];
}
